module.exports = __webpack_public_path__ + "static/img/recharge_active.38063ebe.png";